import _Message2 from "element-ui/lib/theme-chalk/message.css";
import "element-ui/lib/theme-chalk/base.css";
import _Message from "element-ui/lib/message";
import _classCallCheck from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/createClass.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
var showMessage = Symbol('showMessage');
var DonMessage = /*#__PURE__*/function () {
  function DonMessage() {
    _classCallCheck(this, DonMessage);
  }
  return _createClass(DonMessage, [{
    key: "success",
    value: function success(options) {
      var single = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this[showMessage]('success', options, single);
    }
  }, {
    key: "warning",
    value: function warning(options) {
      var single = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this[showMessage]('warning', options, single);
    }
  }, {
    key: "info",
    value: function info(options) {
      var single = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this[showMessage]('info', options, single);
    }
  }, {
    key: "error",
    value: function error(options) {
      var single = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this[showMessage]('error', options, single);
    }
  }, {
    key: showMessage,
    value: function value(type, options, single) {
      if (single) {
        // 判断是否已存在Message
        if (document.getElementsByClassName('el-message').length === 0) {
          _Message[type](options);
        }
      } else {
        _Message[type](options);
      }
    }
  }]);
}();
export default new DonMessage();